export default __webpack_public_path__ + "static/5-chef-page-a4ca1fa22978105dfdb4dfe7a80599df.jpg";